module.exports = ".logo-cert{width:340px;height:200px}\n"